import { Clock } from 'lucide-react';
import EventCard from './EventCard';

const HistoryTimeline = ({ events, maxEvents = 5, usersMap = {}, canCancel = false, onCancel, onUncancel, actionLoading = null }) => {
  if (!events || events.length === 0) {
    return (
      <div className="text-center py-4 text-light-text-tertiary dark:text-dark-text-tertiary">
        <Clock className="h-8 w-8 mx-auto mb-2 text-light-text-tertiary dark:text-dark-text-tertiary" />
        <p className="text-sm">No change history available</p>
      </div>
    );
  }

  const displayedEvents = events.slice(0, maxEvents);

  return (
    <div className="space-y-3">
      {displayedEvents.map((event) => (
        <EventCard
          key={event.id}
          event={event}
          usersMap={usersMap}
          canCancel={canCancel}
          onCancel={onCancel}
          onUncancel={onUncancel}
          actionLoading={actionLoading}
        />
      ))}
    </div>
  );
};

export default HistoryTimeline;
